import meta from './bankrate-tracking/meta'

window.dataLayer = window.dataLayer || []

setDataLayer()

function setDataLayer() {
  let newLayer = {
    adArea: 'AdArea',
    adKeywords: 'AdKeyword',
    primaryCategory: 'Category',
    cobrand: 'Site',
    pageType: 'PageType',
    subCategories: 'SubCategories',
    content: {
      author: 'Author',
      date: 'Published',
      funnelStage: 'FunnelStage',
      targetPersona: 'TargetPersona',
      objective: 'Objective',
      topic: 'Topic'
    }
  }
  eachRecursive(newLayer, function(obj, key) {
    let value = meta.getMetaData(obj[key])
    obj[key] = value && key !== 'title' ? value : null
  })
  newLayer.content.title = window.document.title
  newLayer.pageUX = meta.getPageUX()
  newLayer.environ = 'cb'
  newLayer.event = 'preload'

  window.dataLayer.push(newLayer)
}

function eachRecursive(obj, cb) {
  for (let k in obj) {
    if (!obj.hasOwnProperty(k)) {
      continue
    }

    if (typeof obj[k] === 'object' && obj[k] !== null) {
      eachRecursive(obj[k], cb)
    } else {
      if (cb) {
        cb(obj, k)
      }
    }
  }
}

export function getBrOption(key) {
  let brPageOptions = window.brPageOptions || []
  let option = brPageOptions.filter(function(item) {
    return item && item[0] && item[0] === key
  })

  if (Array.isArray(option) && option.length === 1) {
    option = option[0][1]
  }

  if (Array.isArray(option) && option.length === 0) {
    option = null
  }

  return option
}
